<template>
  <div
    :class="{
      inlineCart: true,
      openDrawer: openStyle == 'drawer',
      athenaDrawer: theme == 'athena',
    }"
    @mousedown="close"
  >
    <div class="inlineCart__content" @mousedown.stop @click.stop>
      <div class="inlineCart__allow">
        <span class="inlineCart__allow-content" />
      </div>
      <div
        :class="{
          inlineContent: true,
          'inlineContent--show': drawerShow,
          'inlineContent--dark': global_cart_config.type == 'drawer' && cartStyle == 'dark'
        }"
      >
        <div class="cartHeader">
          <button class="iconfont icon-cancel-1-copy" @click="close"></button>
          <h2 class="title_font" style="text-transform: capitalize" :class="theme == 'vogue'? 'text-uppercase':''">{{ $t("cart.your_cart") }}</h2>
        </div>
        <div class="cartContent">
        <a
          style="display: block; padding: 0 0px 20px"
          :href="banner_url ? banner_url : null"
          v-if="(pc_image && pc_image.url) || (mobile_image && mobile_image.url)"
        >
          <v-lazy-img
            style="width: 100%; object-fit: cover"
            :data-url="(mobile_image && mobile_image.url) || (pc_image && pc_image.url)"
            :src="(mobile_image && mobile_image.thumbnail) || (pc_image && pc_image.thumbnail)"
          ></v-lazy-img>
        </a>
        <!-- 特殊属性提示 -->
        <div class="special_attrs" v-if="special_attrs_num.has_odd">
          <div class="special_attrs_content">
            <span class="icon-2 iconfont"></span>
            <span>
              Update lenses marked <span style="color: red"> "Qty 1=1 eye" </span> to even quantities to receive them
              in pair(s).
            </span>
          </div>
        </div>
        <p class="title text-center" v-if="global_cart_config.type == 'drawer'">
          {{ global_cart_config.drawer && global_cart_config.drawer.text }}
        </p>
          <div class="cart-free-shipping" v-if="freeShippingOnOff.onOff" :style="{'padding-top':global_cart_config.type == 'popup'?'10px':''}">
            <v-cart-free-sp-tips :freeShippingOnOff="freeShippingOnOff"></v-cart-free-sp-tips>
          </div>
          <div class="cart-content__body">
            <div v-if="cartmes && cartmes.cart_contents_count">
              <div class="cart-content__cart-item-wrapper">
                <v-drawer-cart-item
                  v-for="item in cartmes.cart"
                  :theme="theme"
                  type="drawer"
                  :input_type="
                    theme == 'athena' ? 'athenaRight' : 'controlRight'
                  "
                  :key="item.key"
                  :cartItem="item"
                  :special_attrs_num="special_attrs_num"
                  :disabled_num="disabled_num"
                  :changequantity="changequantity"
                  :show_currency_selector="show_currency_selector"
                  :cart-product-id="item.product.ID"
                ></v-drawer-cart-item>
              </div>
              <v-cartnote
                v-if="cartNoteOff"
                :style="{ borderBottom: 'none' }"
                :cart_note="cartmes && cartmes.cart_note"
                :note_content_style="{ width: '100%', marginTop: '10px' }"
                :class="{ cartnote_vogue: theme == 'vogue' }"
              ></v-cartnote>
              <div class="continue d-md-none d-blcok" v-if="global_cart_config.type == 'popup'" :a="global_cart_config.type " @click="close">
                {{ $t("shopping.continue_shipping") }}
              </div>
            </div>
            <div
              class="emptyCart"
              :class="{ 'empty-drawer': global_cart_config.type == 'drawer' }"
              v-else
            >
              <p class="empty">{{ $t("cart.vogue.empty") }}</p>
              <div
                class="btn-all"
                v-if="
                  global_cart_config.type == 'drawer' &&
                  global_cart_config.drawer
                "
              >
                <template
                  v-for="(item, index) in global_cart_config.drawer.button"
                >
                  <a
                    class="
                      transition-minor
                      vogue-home-btn
                      button
                    "
                    :href="item.url"
                    v-if="item.url && item.title"
                    :key="index"
                    >{{ item.title }}</a
                  >
                </template>
              </div>
              <a
                :href="
                  global_cart_config.drawer &&
                  global_cart_config.drawer.image_link
                "
              >
                <img
                  v-if="global_cart_config.type == 'drawer'"
                  :src="
                    global_cart_config.drawer &&
                    global_cart_config.drawer.image_url
                  "
                  alt
                />
              </a>
            </div>
            <v-guess-like
              :comment="comment"
              v-if="recommended_product && show_recommended && got_cartmes"
              :recommended_product="recommended_product"
              :inline_cart="true"
              :hide_container="true"
              cart_type="inCart"
              :product_id="product_ids"
              :show_currency_selector="show_currency_selector"
              theme="vogue"
              :beforeAdd="() => beforeAdd()"
              :onAdded="scrollerBack"
              :swiper_style="swiper_style"
            ></v-guess-like>
          </div>
        </div>

        <div class="drawer_inner_foot main_button_boder">
          <div class="drawer_inner_foot_price" v-if="theme=='vogue'">
            <p class="secondary_title">{{ $t('cart.subtotal') }}</p>
            <p>
              <v-selectprice
                :price="complete_subtotal"
                :country="show_currency_selector ? $store.state.pricetype : ''"
                :disable_select="true"
                :fontSize="16"
              ></v-selectprice>
            </p>
          </div>
          <div id="discount_price" class="drawer_inner_foot_price" v-if="cartmes.discount_cart">
            <p class="secondary_title" v-if="cartmes.coupons.length">
              <span class="iconfont icon-cm-biaoqian"></span>
              {{
                Object.values(cartmes.coupons)[0].description
                  ? Object.values(cartmes.coupons)[0].description
                  : Object.values(cartmes.coupons)[0].code
              }}
            </p>
            <p class="secondary_title" v-else>{{ $t("shopping.discount") }}</p>
            <p>
              -
              <v-selectprice
                :country="show_currency_selector ? $store.state.pricetype : ''"
                :price="cartmes.discount_cart"
                :disable_select="true"
                :fontSize="theme=='vogue'?14:12"
              ></v-selectprice>
            </p>
          </div>
          <div class="drawer_inner_foot_price" v-if="theme=='athena'">
            <p class="secondary_title">{{ $t("cart.subtotal") }}</p>
            <p>
              <v-selectprice
                :price="complete_subtotal"
                :country="show_currency_selector ? $store.state.pricetype : ''"
                :disable_select="true"
                :fontSize="12"
              ></v-selectprice>
            </p>
          </div>
          <div class="shopping-carbody-list-foot-tip">
            {{ $t("cart.Taxes_shipping_checkout") }}
          </div>
          <!-- <div class="drawer_inner_foot_price" v-if="cartmes.cart_total">
              <p class="secondary_title">{{ $t("shopping.total") }}</p>
              <p>
                <v-selectprice
                  :price="cartmes.cart_total"
                  :country="show_currency_selector?$store.state.pricetype:''"
                  :disable_select="true"
                  :fontSize="12"
                ></v-selectprice>
              </p>
            </div> -->
          <div class="checkout_flex">
            <button
              class="checkout secondary_title"
              :class="[
                theme == 'vogue' ? 'transition-main' : 'main_button',
                { button_active: checkout_active },
              ]"
              :disabled="checkout_active"
              style="margin-top: 15px"
              :style="
                theme == 'athena' &&
                !(paypalPosition == 'cart' || paypalPosition == 'both')
                  ? 'margin-right:0;width:100%'
                  : ''
              "
              @click="checkout"
              type="button"
            >
              <span>
                {{
                  cartmes.cart_contents_count
                    ? $t("cart.check_out")
                    : $t("shopping.continue_shipping")
                }}
              </span>
            </button>
            <v-paypal-btn
              v-if="paypalPosition == 'cart' || paypalPosition == 'both'"
              v-show="!emptyCart"
              style="margin-top: 15px; position: relative; z-index: 1"
              :cartmes="JSON.stringify(cartmes)"
            ></v-paypal-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vDrawerCartItem from "@/js/components/common/drawerCartItem.vue";
import vCartitem from "@/views/venue/js/common/cartitem";
import vCartnote from "./cartnote";
import vGuessLike from '@/js/components/view/guesslike/guesslike';
import mixCart from "@/js/mixins/mixCart";
import vCartFreeSpTips from "@/views/vogue/js/common/cartFreeSpTips.vue";
import { mapState } from 'vuex';
export default {
  props: [
    "comment",
    "theme",
    "parentEl",
    "openStyle",
    "cartNoteOff",
    "paypalPosition",
    "show_currency_selector",
    "global_cart_config",
    "recommended_product",
    "cart_type",
    "pc_image",
    "mobile_image",
    "banner_url",
    "swiper_style",
    'free_shipping',
  ],
  mixins: [mixCart],
  data() {
    return {
      cartmes: {},
      disabled_num: false,
      checkout_active: false,
      newParentEl: null,
      show_recommended: false,
      special_attrs_num: { total: 0 },
      drawerShow: false,
      got_cartmes: false,
      cartItemHeight: 0
    };
  },
  computed: {
      freeShippingOnOff() {
      let freeShipping = {
        onOff: false,
        freeProcessOnOff: false,
        free_amount: 0,
        agio: 0,
        percentage: 0,
      }
      if(!this.free_shipping) return freeShipping;
      let { free_tip, free_amount, free_process } = this.free_shipping
      if (free_tip && free_amount !== null && this.complete_subtotal) {
        freeShipping.onOff = true
        freeShipping.free_amount = free_amount
      }
      freeShipping.agio = free_amount - this.complete_subtotal
      freeShipping.percentage = ((this.complete_subtotal / free_amount) * 100) | 0
      freeShipping.freeProcessOnOff = free_process
      return freeShipping
    },
    product_ids() {
      if (!this.cartmes.cart) return;
      let products = Object.values(this.cartmes.cart);
      let ids = [];
      if (!products.length) return "";
      products.forEach((item) => {
        ids.push(item.product_id);
      });
      return ids.join(",");
    },
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    },
    ...mapState({
      // 抽屉购物车风格
      cartStyle: ({ options }) => options?.theme?.global?.cart?.style || 'bright',
    }),    
  },
  methods: {
    async changequantity(quantity, key, product_id, variant_id) {
      if(this.disabled_num) return;
      this.disabled_num = true;
      let product_argument = variant_id
        ? { quantity, product_id, variant_id }
        : { quantity, product_id };
      try {
        var res = await this.$axios.put(
          API.changequantity + key,
          {...product_argument,tag:'store'}
        );
        this.disabled_num = false;
        this.cartmes = res.data;
        this.$store.dispatch("change_news_cart", res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
      } catch (error) {
        this.disabled_num = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    show() {
      if (this.openStyle == "drawer") {
        // let right_width = window.innerWidth > 590 ? "400px" : "300px";
        // this.$("#app").css({position: "relative"}).animate({ right: right_width },300);
        this.$(this.$el).show();
        this.$(".openDrawer .inlineCart__content").animate(
          { right: "0px" },
          300
        );
        setTimeout(() => {
            this.$('body').css({ overflow: 'hidden', 'touch-action': 'none', '-ms-touch-action': 'none' })
        }, 200);
      } else if (this.openStyle == "popup") {
        this.$(this.$el).show();
        if (window.innerWidth < 768) {
          setTimeout(() => {
            this.$('body').css({ overflow: 'hidden', 'touch-action': 'none', '-ms-touch-action': 'none' })
          }, 200)
        }
      } else {
        this.$(this.$el).toggle();
      }
    },
    close(e) {
      if (e.target === this.newParentEl) return;
      if (this.openStyle == "drawer") {
        let right_width = window.innerWidth > 590 ? "-400px" : "-300px";
        // this.$("#app").animate({ right: "0" }, 400);
        this.$(".openDrawer .inlineCart__content").animate(
          { right: right_width },
          400,
          () => {
            this.$(this.$el).hide();
          }
        );
      } else {
        this.$(this.$el).css("display", "none");
      }
      this.$("body").css({ overflow: "", 'touch-action': '', '-ms-touch-action': '' });
    },
    checkout() {
      if (!this.cartmes.cart_contents_count) {
        window.open("/collections/all", "_self");
        return;
      }
      let cart_hash = this.getCookie("cart_hash");
      this.checkout_active = true;
      let cart_item = Object.values(this.cartmes.cart);
      let content_ids = [];
      let product_category_ids = [];
      cart_item.forEach((item) => {
        content_ids.push(item.product_id);
        if (item.category_ids) {
          product_category_ids = product_category_ids.concat(item.category_ids);
        }
      });
      if (window.fbq) {
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        this.send_fb_event("InitiateCheckout", {
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD",
        });
      }
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('InitiateCheckout')
      }
      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href },
      });
      this.$axios.post(API.statis_event, {
        name: "checkout.check",
        parameters: { url: window.location.href },
      });
      // if (window.gtag) {
      //   window.gtag("event", "cart.check");
      // }
      if (window._learnq) {
        this.klaviyo_checkout(this.cartmes);
      }
      // if (window.snaptr) {
      //     window.snaptr('track', 'START_CHECKOUT', {
      //         'currency': this.cartmes.currency ? this.cartmes.currency : "USD",
      //         'item_category': null,
      //         'item_ids': this.content_ids,
      //         'number_items': this.cartmes.cart_contents_count,
      //         'price': this.cartmes.cart_total,
      //     })
      // }

      setTimeout(() => {
        this.checkout_active = false;
      }, 3000);
      this.toCheckInfo(cart_hash);
    },

    // 加购之前
    beforeAdd() {
      // 购物车商品列表的高度
      this.cartItemHeight =
        this.$(".cart-content__cart-item-wrapper")?.height() || 0;
    },
    // 加购后，要滚动回到物品列表，定位在最后一行
    scrollerBack(product = {}) {
      const { productId } = product;

      // 同一个商品加购, 判断购物车里是否有该商品，并计算位置
      const dom = this.$(`[cart-product-id='${productId}']`);

      let height = this.cartItemHeight;
      if (productId && dom?.length > 0) {
        height = dom[0].offsetTop;
      }

      this.$(".inlineCart .cartContent").animate(
        {
          scrollTop: height,
        },
        500
      );
    },
  },
  async beforeMount() {
    Vue.prototype.showInlineCart = this.show;
    try {
      let res = await this.$axios.get(API.addcart);

      this.cartmes = res.data;
      this.got_cartmes = true;
      this.$store.dispatch("change_news_cart", res.data);
      this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
      localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        this.$message.error(Object.values(error.response.data.errors)[0][0]);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        this.$message.error(error.response.data.message);
      }
    }
  },
  mounted() {
    if (this.theme == "athena") {
      this.special_attrs_num = this.computed_special_attrs(this.cartmes);
    }
    if (this.recommended_product) {
      this.show_recommended = this.recommended_product.shopCart == 1;
    }
    if (this.parentEl) {
      this.$("." + this.parentEl).click((e) => {
        e.preventDefault();
        this.newParentEl = e.target;
        if (window.innerWidth < 768) {
          this.$("body").css({ overflowY: "hidden" });
        }
        this.show();
      });
    }
    if(window.innerWidth<768||this.openStyle == "drawer"){
      document.body.appendChild(this.$el)
    }
    if (this.openStyle == "popup") {
      document.body.addEventListener(
        "click",
        this.debounce(this.close, 200),
        false
      );
    }
  },
  watch: {
    "$store.state.news_cart"(newV) {
      this.cartmes = this.$store.state.news_cart;
      if (this.theme == "athena") {
        this.special_attrs_num = this.computed_special_attrs(newV);
      }
    },
  },
  components: {
    vDrawerCartItem,
    vCartitem,
    vCartnote,
    vCartFreeSpTips,
    vGuessLike,
  },
};
</script>
<style scoped lang='scss'>
.inlineCart {
  display: none;
  padding: 18px 0 0;
  position: absolute;
  top: 15px;
  right: -16px;
  // 抽屉弹窗理论最高层
  // 高于聊天插件(202)
  // 高于悬浮菜单(201)
  // 高与最近浏览记录(199)
  // 最近售卖弹窗(204)
  z-index: 205;
  &.openDrawer {
    // 抽屉式弹窗
    z-index: 1100;
  }
  &__allow {
    position: absolute;
    display: block;
    width: 40px;
    height: 18px;
    overflow: hidden;
    pointer-events: none;
    top: 0;
    right: 5px;
    transform: translateX(-50%);
  }
  &__allow-content {
    box-shadow: -1px 3px 10px rgb(0 0 0 / 16%);
    transform: translateY(11px) rotate(45deg);

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 18px;
    height: 18px;
    margin: auto;
    background-color: #fff;
    content: "";
    pointer-events: auto;
  }
  &__content {
    .inlineContent {
      padding-top: 4px;
      margin: 0;
      background-color: white;
      box-shadow: -1px 3px 10px rgb(0 0 0 / 16%);
      width: 380px;
      text-transform: initial;
      text-align: left;
      .cartHeader {
        display: none;
        padding: 12px 24px;
        button {
          position: absolute;
          top: 0;
          left: 0;
          height: 48px;
          width: 48px;
          line-height: 48px;
          text-align: center;
          font-weight: 600;
        }
        h2 {
          font-size: 21px;
        }
      }
      .cartContent {
        padding: 8px 10px;
        overflow-y: auto;
        max-height: 374px;
        & > div:not(:nth-last-child(1)):not(:nth-last-child(2)) {
          border-bottom: 1px solid #e2e2e2;
        }
        .continue {
          width: 100%;
          height: 44px;
          background: #f5f5f5;
          font-size: 14px;
          color: #222;
          line-height: 44px;
          text-align: center;
          color: #3a68ff;
          text-decoration: underline;
          cursor: pointer;
          border-top: 1px solid #e2e2e2;
        }
      }
      .cart-content {
        &__body {
          position: relative;
        }
      }
      .title {
        font-size: 14px;
        line-height: 22px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 30px;
      }
      .emptyCart {
        padding: 20px 0;
        font-size: 20px;
        text-align: center;
        flex: 1;
        line-height: 1;
      }
      .empty-drawer {
        // position: relative;
        display: flex;
        flex-direction: column;
        padding-top: 0;
        padding-bottom: 0;
        line-height: 1 !important;

        .empty {
          margin-top: 80px;
        }
        .btn-all {
          flex: 1;
          padding: 0 20px;
          .button {
            display: block;
            width: 100%;
            font-size: 20px;
            margin-top: 24px;
            padding: 18px 22px;
            background: #ffffff;
            border: 2px solid #222222;
          }
        }
        img {
          // position: absolute;
          // left: 0;
          // bottom: 0;
          max-height: 90px;
          object-fit: cover;
          width: 100%;
          padding: 5px 13px 8px;
        }
      }
      .drawer_inner_foot {
        padding-top: 15px;
        padding: 16px 12px 12px;
        box-shadow: 0px -2px 8px 0px #eeeeee;
          #discount_price p {
            font-size: 14px;
            color: #999;
            &::v-deep {
              .product_price_price {
                .money {
                  font-size: 14px !important;
                  color: #999 !important;
                }
              }
            }
          }
        .drawer_inner_foot_price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          word-break: break-word;
          height: 30px;
          p {
            margin: 0;
            flex: 1;
            line-height: 1;
          }
          p:first-child {
            font-size: 16px;
            margin: 0;
            font-weight: 500;
            line-height: 1;
            font-style: normal;
            text-transform: uppercase;
            &::first-letter {
              text-transform: uppercase;
            }
          }
          p:last-child {
            text-align: right;
          }
        }
        .drawer_inner_foot_info {
          text-align: center;
          font-size: 12px;
          color: #3a3a3a;
          margin-bottom: 15px;
          opacity: 0.7;
        }
        .checkout {
          width: 100%;
          display: inline-block;
          padding: 14px 20px;
          border: none;
          line-height: 1;
          background: rgb(201, 13, 13);
          color: white;
          font-weight: 600;
          font-style: normal;
          text-transform: uppercase;
          font-size: 16px;
          border-radius: 0;
          cursor: pointer;
          &:hover {
            background: rgb(241, 34, 34);
          }
        }
      }
      &--dark {
        filter: invert(1) hue-rotate(180deg);
        &::v-deep {
          img {
            filter: invert(1) hue-rotate(180deg);
            transition: auto !important;
          }
          .checkout_flex {
            filter: invert(1) hue-rotate(180deg);
          }
          .cart-currency-tip {
            filter: invert(1) hue-rotate(180deg);
            color: #fff;
            background: #ffa9457a;
            border: none;
          }
          .select-style-box {
            select {
              filter: invert(1) hue-rotate(180deg);
              color: #fff !important;
              background: #000 !important;           
            }
          }
          #discount_price p .product_price_price .money.price_text {
            color: #fff !important;
          }
          .cartHeader button,
          .cartHeader h2,
          .drawer_inner_main_item_right_name a,
          .drawer_inner_main_item_right_variant span,
          .remove,
          .guess_title,
          .product_title,
          .default-select-dropdown::after,
          .add-card-btn,
          .drawer_inner_foot_price > p.secondary_title,
          .money.price_text,
          .controlRight button,
          #discount_price .product_price_price,
          #discount_price >p:last-child,
          p.title,
          .btn-all
          {
            filter: invert(1) hue-rotate(180deg);
            color: #fff !important;           
          }
        }
      }      
      }
  }
}
.openDrawer {
  position: fixed;
  background: rgba(255, 255, 255, 0.7);
  width: 100vw !important;
  height: 100vh !important;
  top: 0;
  left: 0 !important;
  display: none;
  padding-top: 0;
  .inlineCart {
    &__allow {
      display: none;
    }
    &__content {
      position: fixed;
      right: -400px;
      width: 400px;
      height: 100%;
      .inlineContent {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background: white;
        .cartHeader {
          display: block;
          text-align: center;
          font-size: 21px;
        }
        .cartContent {
          flex: 1;
          max-height: unset;
        }
        .emptyCart {
          line-height: 10;
        }
        .drawer_inner_foot {
          #discount_price {
            color: #999;
            p:first-child {
              font-size: 14px !important;
            }
          }
          p:first-child {
            font-size: 16px;
          }
          border-top: unset;
          box-shadow: 0 -6px 12px 0 rgb(0 0 0 / 4%);
        }
      }
    }
  }
}
.athenaDrawer {
  .inlineContent {
    width: 500px !important;
    .cartHeader {
      padding: 25px 30px;
      button {
        left: unset;
        right: 30px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        top: 30px;
        border: 1px solid #000;
        border-radius: 50%;
        font-size: 7px;
      }
      h2 {
        text-align: left;
        font-size: 24px;
      }
    }
    // .title {
    //   display: none;
    // }
    .cartContent {
      padding: 15px 30px;
      &::v-deep .drawer_inner_main_item {
        .drawer_inner_main_item_left {
          max-width: 120px;
          width: 28%;
        }
      }
      &::v-deep {
        .guess_like {
          margin-top: 30px;
          // .guess_title {
          //   display: none;
          // }
          .add-card {
            padding: 20px;
          }
          .add-card-main {
            .add-product {
              .add-pro-left {
                width: 30%;
                max-width: 120px;
              }
              .add-pro-title {
                font-size: 16px;
                line-height: 16px;
              }
              span.money {
                font-size: 16px !important;
              }
              .add-btn {
                margin-top: 15px;
                display: block !important;
                .add-button {
                  span {
                    font-size: 16px;
                  }
                }
              }
            }
            .add-bottom {
              display: none !important;
            }
          }
          .athena_hidden {
            display: none;
          }
          .m_hidden {
            display: block;
          }
          .swiper-command {
            width: 100%;
            bottom: -60px;
            text-align: center;
            span {
              margin-right: 4px;
              width: 16px;
              height: 8px;
              border-radius: 4px;
            }
            .swiper-pagination-bullet-active {
              transition: width 0.5s;
              width: 32px;
              background: #000;
            }
          }
        }
      }
    }
    .drawer_inner_foot {
      padding: 30px;
      line-height: initial;
      .drawer_inner_foot_price.drawer_coupons_price {
        margin-bottom: 10px;
        p {
          font-size: 16px;
          color: #8e929e;
        }
        &::v-deep {
          #select_price {
            .product_price_price .price_text {
              font-size: 16px !important;
              color: #8e929e !important;
            }
          }
        }
      }
      .drawer_inner_foot_price.drawer_total_price {
        p {
          font-size: 20px;
        }
        &::v-deep {
          .product_price_price .price_text {
            font-size: 20px !important;
          }
        }
      }
      .checkout {
        padding: 17px;
        font-size: 20px;
        margin-bottom: 5px;
      }
    }
    .continue {
      display: none !important;
    }
    .checkout_flex {
      display: flex;
      flex-direction: column;
      .checkout {
        width: 100%;
        margin-right: 20px;
        span {
          font-size: 16px;
        }
      }
      .paypal-button-render {
        width: 100%;
      }
    }
    .checkout:hover {
     filter: opacity(80%);
    }
    .button_active{
     filter: opacity(60%);
    }
    &::v-deep .drawer_inner_main_item {
      padding: 0 0 30px 0;
      margin-bottom: 30px;
      border-bottom: 1px solid #eee;
      line-height: initial;
      .drawer_athena {
        padding-left: 20px !important;
        width: 70%;
        .drawer_inner_main_item_right_name {
          line-height: inherit !important;
          margin-bottom: 14px !important;
          a {
            font-size: 16px !important;
            line-height: 16px !important;
            color: #222222 !important;
          }
        }
        .drawer_inner_main_item_right_variant {
          margin-bottom: 20px !important;
          padding-top: 0 !important;
          span {
            font-size: 16px !important;
          }
        }
        .price_type {
          margin-bottom: 13px;
          .product_price_price {
            .price_text {
              font-size: 16px !important;
            }
          }
        }
        .drawer_inner_main_item_right_price {
          display: flex;
          align-items: center;
          margin-top: 0;
          .remove {
            margin-left: 20px;
            span {
              font-size: 14px !important;
              padding-top: 0 !important;
            }
          }
        }
        .product_qty {
          button {
            width: 32px;
            height: 32px;
            line-height: 32px;
            span {
              font-size: 16px;
            }
          }
          input {
            width: 60px;
            height: 32px;
            line-height: 32px;
            font-size: 16px;
            background: #fff;
          }
        }
      }
    }
  }
  .inlineCart__content {
    width: 500px !important;
  }
}
.special_attrs {
  display: flex;
  align-items: center;
  height: 88px;
  background: #feeeee;
  font-size: 18px;
  margin: 0 0 40px 0;
  .special_attrs_content {
    width: 90%;
    display: flex;
    margin-left: 30px;
    span {
      line-height: 28px;
    }
    .iconfont {
      font-size: 26px;
      color: #a72d2d;
      margin: 0 21px 0 0;
    }
  }
}
.cartnote_vogue {
  &::v-deep {
    .note_content {
      p {
        top: -33px !important;
        right: 9px !important;
      }
      .hidden_length_tip {
        display: none;
      }
    }
  }
}


@media screen and (max-width: 768px) {
  .inlineCart {
    position: fixed;
    width: 100%;
    padding-top: 0;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1100;
    &__allow {
      display: none;
    }
    .inlineCart__content{
      height: 100%;
    }
    .inlineContent {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .cartHeader {
        display: block;
        text-align: center;
        font-size: 21px;
      }
      .cartContent {
        flex: 1;
        max-height: unset;
      }
      .emptyCart {
        line-height: 10;
      }
      .title {
        font-size: 12px;
      }
      .empty-drawer {
        .empty {
          margin-top: 28px;
        }
        .btn-all {
          padding: 0 10px;
          .button {
            font-size: 14px;
            padding: 13px 22px;
          }
        }
      }
      .drawer_inner_foot {
        border-top: unset;
        box-shadow: 0 -6px 12px 0 rgb(0 0 0 / 4%);
      }
    }
  }
  .openDrawer {
    .inlineContent {
      &::v-deep
        .guess_list_wrap
        .inline-guesslike-list_box
        .add-card
        .add-button {
        font-size: 13px;
      }
    }
  }
  .athenaDrawer {
    .inlineContent {
      width: 100% !important;
      .cartHeader {
        padding: 15px;
        button {
          right: 15px;
          top: 15px;
        }
        h2 {
          margin-top: 0;
          font-size: 18px;
        }
      }
      .cartContent {
        padding: 20px 15px;
        border-bottom: 1px solid #dedede;
        &::v-deep .drawer_inner_main_item {
          .drawer_inner_main_item_left {
            max-width: 120px;
          }
        }
        &::v-deep {
          .guess_like {
            margin-top: 30px;
            .add-card {
              padding: 10px;
            }
          }
        }
      }
      .drawer_inner_foot {
        padding: 20px 15px;
        .drawer_inner_foot_price.drawer_coupons_price {
          margin-bottom: 15px;
          p {
            font-size: 14px;
            color: #8e929e;
          }
          &::v-deep {
            #select_price {
              .product_price_price .price_text {
                font-size: 14px !important;
                color: #8e929e !important;
              }
            }
          }
        }
        .drawer_inner_foot_price.drawer_total_price {
          p {
            font-size: 15px;
          }
          &::v-deep {
            .product_price_price .price_text {
              font-size: 15px !important;
            }
          }
        }
        .checkout {
          padding: 19px;
          font-size: 16px;
        }
        &::v-deep {
          .guess_like {
            margin-top: 20px;
            max-height: 150px;
            overflow-y: auto;
            .guess_title {
              display: none;
            }
            .add-card {
              padding: 12px;
            }
            .add-card-main {
              .add-product {
                .add-pro-left {
                  width: 26%;
                }
                .add-pro-title {
                  font-size: 15px;
                  line-height: 15px;
                }
                span.money {
                  font-size: 15px !important;
                }
                .add-pro-select {
                  margin-bottom: 15px;
                }
                .add-btn {
                  .add-button {
                    span {
                      font-size: 14px;
                    }
                  }
                }
              }
              .add-bottom {
                display: none !important;
              }
            }
          }
        }
      }
      .checkout_flex {
        justify-content: space-between;
        .checkout {
          width: 100%;
          span {
            font-size: 16px;
          }
        }
        .paypal-button-render {
          width: 100%;
        }
      }
      &::v-deep .drawer_inner_main_item {
        display: block;
        padding-bottom: 10px;
        .drawer_athena {
          padding-left: 15px !important;
          .drawer_inner_main_item_right_name {
            line-height: inherit !important;
            margin-bottom: 5px !important;
            a {
              font-size: 15px !important;
              line-height: 21px !important;
              color: #222222 !important;
            }
          }
          .drawer_inner_main_item_right_variant {
            margin-bottom: 15px !important;
            span {
              font-size: 13px !important;
            }
          }
          .price_type {
            margin-bottom: 5px;
            .product_price_price {
              .price_text {
                font-size: 15px !important;
              }
            }
          }
          .drawer_inner_main_item_right_price {
            display: flex;
            align-items: center;
            .remove {
              margin-left: 14.5px;
              span {
                font-size: 13px !important;
                padding-top: 0 !important;
              }
            }
          }
          .product_qty {
            button {
              width: 30px;
              height: 30px;
              line-height: 30px;
              span {
                font-size: 15px;
              }
            }
            input {
              width: 45px;
              height: 30px;
              font-size: 15px;
              background: #fff;
            }
          }
        }
      }
    }
  }
  .special_attrs {
    height: 60px;
    font-size: 13px;
    margin: 0 0 20px 0;
    .special_attrs_content {
      width: 90%;
      margin-left: 15px;
      span {
        line-height: 18px;
      }
      .iconfont {
        font-size: 18px;
      }
    }
  }
}
@media screen and(max-width: 590px) {
  .openDrawer {
    .inlineCart__content {
      width: 300px !important;
      right: -300px;
    }
  }
  .athenaDrawer {
    .inlineContent {
      width: 100% !important;
    }
    .inlineCart__content {
      width: 100% !important;
    }
  }
}
.shopping-carbody-list-foot-tip {
  font-size: 14px;
  text-align: left;
  text-transform: initial;
  word-wrap: break-word;
  margin: 10px 0;
  line-height: 1.5;
}
</style>
